// Share the first cookie/token handshake between writes and realtime negotiation.
// Later handshakes use the existing cookie and re-read the current signed-in identity.
let pending: Promise<string> | null = null;
export function sessionProtectionToken(): Promise<string> {
  if (!pending) pending = fetch('/auth/antiforgery', { credentials: 'same-origin', cache: 'no-store' }).then(async response => {
    if (!response.ok) throw new Error('Impossible d’initialiser la protection de session.');
    const body = await response.json() as { requestToken?: string };
    if (!body.requestToken) throw new Error('La protection de session est indisponible.');
    return body.requestToken;
  }).finally(() => { pending = null; });
  return pending;
}
